import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import UnresolvedMessageBuilderWorkspace from "./UnresolvedMessageBuilderWorkspace";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

class UnresolvedMessageBuilder extends React.Component {

  constructor(props) {
    super(props)
    
    this.state = {
      active_tab: 'message_logs',
      loading: false,
      date_format: this.props.date_format,
      time_format: this.props.time_format,

    }
    this.setActiveTab = this.setActiveTab.bind(this)
  }

  render(){
    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: ['data-dismiss="modal"']
      },
    ]
    return(
      <div className="RoomTypeBuilder">
        <Tabs tabs={this.tabs()}/>
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons}/>
          <UnresolvedMessageBuilderWorkspace {...this.state} {...this.props}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  tabs(){
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'message_logs',
          classes: this.state.active_tab === 'message_logs' ? 'active' : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t('reservations'),
          targetName: 'reservations',
          classes: this.state.active_tab === 'reservations' ? 'active' : null,
          changeHandler: this.setActiveTab,
        },
        {
          tabName: I18n.t('customers'),
          targetName: 'customers',
          classes: this.state.active_tab === 'customers' ? 'active' : null,
          changeHandler: this.setActiveTab,
        },
      ]
    );
  };

  setActiveTab(name) {
    this.setState({active_tab: name})
  }
}

export default UnresolvedMessageBuilder
